import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "antd/dist/antd.min.css";
import "../styles/Main.scss";
import { postRequest } from "../axios";
import { SuccessNotificationMsg } from "../utils/Notifications";
import ButtonField from "../common/htmlComponents/ButtonField";
import logo from "../image/smartbuyerLogo.png";
import { Form } from "antd";
import EmailPRApprovalNew from "./EmailPRApprovalNew";

const ApprovalForPR = () => {
    const navigate = useNavigate();
    const [btnLoading, setBtnLoading] = useState(false);
    const { resetToken, id, prType } = useParams();

    const handleSubmit = async () => {

        try {
            setBtnLoading(true);
            await postRequest("purchase-requisition/pr-approve-by-email/" + resetToken + "/"+ `${id}` + "/" + prType +`/?action=Approve`).then(
                // await postRequest("purchase-requisition/pr-approval/" + resetToken + "/" + `${id}`).then(

                (response) => {
                    SuccessNotificationMsg("PR Approved Successfully");
                    // setTimeout(handleNavigate, 2000);
                    //setTimeout(handleNavigate, 4000);
                }
            );
            setBtnLoading(false);
            navigate("/purchase-requisition-history")
        } catch (error) {
            setBtnLoading(false);
        }
    };

    useEffect(() => {
        // Trigger handleSubmit automatically after 5 seconds (5000 milliseconds)
        const timer = setTimeout(() => {
            handleSubmit();
        }, 100);

        // Clean up the timer if the component unmounts before the timeout completes
        return () => clearTimeout(timer);
    }, [resetToken, id, prType]);

    return null;
 
}

export default ApprovalForPR